import styled from 'styled-components';

import { colors } from '../../constants';

interface IProps {
    textColor: string;
}

export const PackagePriceWrapper = styled.div`
    position: relative;
`;

export const PackagePriceDisplay = styled.div<IProps>`
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: ${colors.white};
    color: ${({ textColor }) => textColor};
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Campton', Arial, Helvetica, sans-serif;
    font-weight: 700;
`;

export const PackagePriceOriginal = styled.span`
    position: absolute;
    top: 18px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    font-size: 1.4rem;
    font-weight: 300;
    color: ${colors.grey};
    text-decoration: line-through;
`;

export const PackagePriceCurrent = styled.span`
    font-size: 2.4rem;
`;

export const PackageDiscountBadge = styled.div`
    position: absolute;
    right: 90px;
    top: -25px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: ${colors.orange};
    color: ${colors.white};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    span {
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1;
    }

    small {
        font-size: 0.85rem;
        font-weight: 400;
        line-height: 1;
        margin-top: 2px;
    }
`;
